<div class="d-flex gap-3">
  <div class="column">
    <span class="label">ID</span>
    <span class="text-primary value">{{ dashboard.id }}</span>
  </div>

  <div class="column">
    <span class="label">name</span>
    <span class="text-primary value">{{ dashboard.name }}</span>
  </div>

  <div class="column">
    <span class="label">typeKey</span>
    <span class="text-primary value">{{ dashboard.typeKey }}</span>
  </div>

  @if (showActionColumn) {
    <div class="column">
      <span class="label">action</span>
      <span class="text-primary value">{{ dashboard.targetId ? 'Update' : 'Create'  }}</span>
    </div>
  }
</div>
